// artist.ts
import { Contract } from "ethers";
import deployment from "./abi/ArtistApprovedCampaign.json";

export const createArtistContract = (
  provider,
  signer,
  address
) => {
  const contract = new Contract(address, deployment.abi, signer);

  const getFailedTransaction = async (transactionHash) => {
    const tx = await provider.getTransaction(transactionHash);
    try {
      await provider.call(tx, tx.blockNumber);
    } catch (err) {
      throw err;
    }
  };

  const isTransactionMined = async (transactionHash) => {
    const txn = await provider.waitForTransaction(transactionHash, 2);
    if (txn && txn.blockNumber && txn.status > 0) {
      return txn;
    } else if (txn.status === 0) {
      await getFailedTransaction(transactionHash);
    } else {
      return false;
    }
  };

  return {
    approveCampaign: async (_id) => {
      let tx = await contract.approveCampaign(_id);
      tx = await isTransactionMined(tx.hash);
      return tx;
    },
  };
};
